import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsIcqComponent } from './simple-icons-icq.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsIcqComponent ],
    exports:      [ SimpleIconsIcqComponent ],
    bootstrap:    []
})
export class SimpleIconsIcqModule {}
